let csvw_url = 'https://www.csvw.com';
export default {
  // kv
  workspace: {},
  // 车型素材
  workspace2: {
    neishi: Array.from({
      length: 16
    }).map((item, i) => {
      return require(`../../assets/passat/imgs/neishi/${i+1}.jpg`)
    }),
    waiguan: Array.from({
      length: 29
    }).map((item, i) => {
      return require(`../../assets/passat/imgs/waiguan/${i+1}.jpg`)
    }),
    qita: Array.from({
      length: 5
    }).map((item, i) => {
      return require(`../../assets/passat/imgs/qita/${i+1}.jpg`)
    }),
    shipin: [
      require("../../assets/passat/imgs/shipin/1.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202108/262041346Y5c.mp4",
    ],
  },
  // 新闻稿
  workspace3: {
    list: [{
        title: '17.99万-25.09万',
        title1: '新帕萨特家族“双前脸”造型焕新上市',
        subtitle: '8月26日， B级轿车新帕萨特正式上市，首度推出“双前脸”造型，进一步满足不同人群的个性化需求。新帕萨特提供280TSI, 330TSI及380TSI 三种动力总成，建议零售价为17.99万元—25.09万元；新帕萨特PHEV提供插电混动商务版、精英版及豪华版三款车型，建议零售价为21.39万元—23.89万元。',
        imgurl: require("../../assets/passat/imgs/xinwen/1.png"),
        imgurlMobile: require("../../assets/passat/imgsMobile/xinwen/1.png"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3133'
      },
    ]
  },
  // 大咖点评
  workspace4: {
    list: [{
        title: require("../../assets/passat/imgs/logo/1.png"),
        titleMobile: require("../../assets/passat/imgs/logo/1.png"),
        subtitle: '新帕萨特采用全新的前脸设计，而且分为点阵式精工格栅和星空式格栅两种风格。新的格栅与LED前大灯组连为一体，增强前脸的视觉宽度。',
        imgurl: require("../../assets/passat/imgs/daka/1.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/1.jpg"),
        url: 'https://www.autohome.com.cn/news/202107/1178034.html'
      },
      {
        title: require("../../assets/passat/imgs/logo/2.png"),
        titleMobile: require("../../assets/passat/imgs/logo/2.png"),
        subtitle: '新帕萨特最大的变化在于加入了贯穿式尾灯的设计，这套尾灯颇有奥迪“灯厂”的姿态，灯腔内部细节很丰富，点亮后很有辨识度。',
        imgurl: require("../../assets/passat/imgs/daka/2.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/2.jpg"),
        url: 'https://newcar.xcar.com.cn/202107/news_2060816_1.html'
      },
      {
        title: require("../../assets/passat/imgs/logo/3.png"),
        titleMobile: require("../../assets/passat/imgs/logo/3.png"),
        subtitle: '新帕萨特传统雾灯区域采用了更加动感的三角造型，使得整车更加年轻化。',
        imgurl: require("../../assets/passat/imgs/daka/3.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/3.jpg"),
        url: 'http://news.yiche.com/danchedaogou/20210717/0015017031.html'
      },
      // {
      //   title: require("../../assets/passat/imgs/logo/4.png"),
      //   titleMobile: require("../../assets/passat/imgs/logo/4.png"),
      //   subtitle: '新帕萨特上格栅中部新增了贯穿式的 LED灯带，为前脸增添不少的科技感。',
      //   imgurl: require("../../assets/passat/imgs/daka/4.jpg"),
      //   imgurlMobile: require("../../assets/passat/imgsMobile/daka/4.jpg"),
      //   url: 'https://www.sohu.com/a/584291428_121374789'
      // },
      {
        title: require("../../assets/passat/imgs/logo/5.png"),
        titleMobile: require("../../assets/passat/imgs/logo/5.png"),
        subtitle: '新帕萨特轮圈使用了18英寸双色花瓣样式，与之搭配的是固特异旗下主打舒适性和操控性的御乘二代系列，前后胎规格均为235/45 R18。',
        imgurl: require("../../assets/passat/imgs/daka/5.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/5.jpg"),
        url: 'https://mini.eastday.com/nsa/210718004425293228936.html'
      },
      {
        title: require("../../assets/passat/imgs/logo/6.png"),
        titleMobile: require("../../assets/passat/imgs/logo/6.png"),
        subtitle: '新帕萨特搭载1.4T和2.0T低/高功率发动机，匹配7速双离合变速箱，发动机最大功率分别为150马力、186马力以及220马力。',
        imgurl: require("../../assets/passat/imgs/daka/6.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/6.jpg"),
        url: 'https://hj.pcauto.com.cn/article/871147'
      },
      {
        title: require("../../assets/passat/imgs/logo/7.png"),
        titleMobile: require("../../assets/passat/imgs/logo/7.png"),
        subtitle: '新帕萨特的中控换装了新款造型的多功能方向盘，后排空调控制也升级为触摸式。',
        imgurl: require("../../assets/passat/imgs/daka/7.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/7.jpg"),
        url: 'https://hj.pcauto.com.cn/article/888866'
      },
      {
        title: require("../../assets/passat/imgs/logo/8.png"),
        titleMobile: require("../../assets/passat/imgs/logo/8.png"),
        subtitle: '新帕萨特大灯升级成了全Led矩阵式IQ Lihgt灯组，实现了智能优化照明效果。',
        imgurl: require("../../assets/passat/imgs/daka/8.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/8.jpg"),
        url: 'https://www.maiche.com/news/detail/2498237.html'
      },
      {
        title: require("../../assets/passat/imgs/logo/9.png"),
        titleMobile: require("../../assets/passat/imgs/logo/9.png"),
        subtitle: '新帕萨特的后保险杠，双边共两出的隐藏式排气布局，增强了车辆尾部的整体感。',
        imgurl: require("../../assets/passat/imgs/daka/9.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/9.jpg"),
        url: 'https://cheshihao.cheshi.com/news/541358.html'
      },
      {
        title: require("../../assets/passat/imgs/logo/10.png"),
        titleMobile: require("../../assets/passat/imgs/logo/10.png"),
        subtitle: '新帕萨特沿用多辐条进气格栅设计，并且进气格栅内部镀铬饰条数量增加，呈矩阵式水平排列。',
        imgurl: require("../../assets/passat/imgs/daka/10.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/10.jpg"),
        url: 'https://baijiahao.baidu.com/s?id=1705710961849464433&wfr=spider&for=pc'
      },
      {
        title: require("../../assets/passat/imgs/logo/11.png"),
        titleMobile: require("../../assets/passat/imgs/logo/11.png"),
        subtitle: '新帕萨特车尾变化非常明显，全新设计的贯穿尾灯内部由多根横条灯带组成，层次感非常强，也让我们看到了在电气化时代，大众燃油车的外观风格也将全面跟进新能源车。',
        imgurl: require("../../assets/passat/imgs/daka/11.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/11.jpg"),
        url: 'https://hj.pcauto.com.cn/article/885804'
      },
      {
        title: require("../../assets/passat/imgs/logo/12.png"),
        titleMobile: require("../../assets/passat/imgs/logo/12.png"),
        subtitle: '新帕萨特车身线条依旧是黄金比例，看起来非常优雅。尾灯与双腰线完美连接，也为侧面增添了力量感。',
        imgurl: require("../../assets/passat/imgs/daka/12.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/12.jpg"),
        url: 'https://ishare.ifeng.com/c/s/88Oy2XDywVd'
      },
      {
        title: require("../../assets/passat/imgs/logo/13.png"),
        titleMobile: require("../../assets/passat/imgs/logo/13.png"),
        subtitle: '新帕萨特装配的尺寸达到18英寸的铝合金轮毂的造型看上去既稳重又不失精致感，与整台车高雅精致的气质相融相和。',
        imgurl: require("../../assets/passat/imgs/daka/13.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/13.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/9107872#pvareaid=28086821202'
      },
      {
        title: require("../../assets/passat/imgs/logo/14.png"),
        titleMobile: require("../../assets/passat/imgs/logo/14.png"),
        subtitle: '新帕萨特在内饰方面依然采用了较为传统的设计风格，10色氛围灯能够提供一定的氛围感，同时后排空间也较为理想。',
        imgurl: require("../../assets/passat/imgs/daka/14.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/14.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/9077076'
      },
      {
        title: require("../../assets/passat/imgs/logo/15.png"),
        titleMobile: require("../../assets/passat/imgs/logo/15.png"),
        subtitle: '新帕萨特光黑装饰板贯通整个仪表台，将仪表盘和中控显示屏构成一体，营造出贯穿式的视觉感受。',
        imgurl: require("../../assets/passat/imgs/daka/15.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/15.jpg"),
        url: 'https://hj.pcauto.com.cn/article/871721'
      },
      {
        title: require("../../assets/passat/imgs/logo/16.png"),
        titleMobile: require("../../assets/passat/imgs/logo/16.png"),
        subtitle: '新帕萨特全新三幅式方向盘，搭配高光黑触摸按键，营造内饰领先的科技运动感。',
        imgurl: require("../../assets/passat/imgs/daka/16.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/16.jpg"),
        url: 'https://new.qq.com/rain/a/20210719A044GO00'
      },
      {
        title: require("../../assets/passat/imgs/logo/17.png"),
        titleMobile: require("../../assets/passat/imgs/logo/17.png"),
        subtitle: '新帕萨特搭载了10.2英寸全液晶仪表和9.2英寸可触控中控屏，支持车联网、CarPlay/CarLife手机互联、语言识别控制系统等功能。',
        imgurl: require("../../assets/passat/imgs/daka/17.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/17.jpg"),
        url: 'https://cheshihao.cheshi.com/news/539457.html'
      },
      {
        title: require("../../assets/passat/imgs/logo/18.png"),
        titleMobile: require("../../assets/passat/imgs/logo/18.png"),
        subtitle: '新帕萨特部分配置新增了后排航空头枕，侧翼可调节，带来头等舱级的体验。',
        imgurl: require("../../assets/passat/imgs/daka/18.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/18.jpg"),
        url: 'https://www.qctt.cn/news/1052398'
      },
      {
        title: require("../../assets/passat/imgs/logo/19.png"),
        titleMobile: require("../../assets/passat/imgs/logo/19.png"),
        subtitle: '新帕萨特搭载多项先进科技配置，如DLA 智能远光灯会车跟车调节、PLA智能泊车辅助系统、Lane Assist 车道保持系统、ACC 高级自适应定速巡航系统等，全方位提升智能体验和驾乘安全性。',
        imgurl: require("../../assets/passat/imgs/daka/19.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/19.jpg"),
        url: 'https://hj.pcauto.com.cn/article/882259'
      },
      // {
      //   title: require("../../assets/passat/imgs/logo/20.png"),
      //   titleMobile: require("../../assets/passat/imgs/logo/20.png"),
      //   subtitle: '新帕萨特座椅采用了质感很好的高档座椅，乘坐起来对腰背的支撑性十分出色，就算是长时间乘坐也不会觉得疲劳。',
      //   imgurl: require("../../assets/passat/imgs/daka/20.jpg"),
      //   imgurlMobile: require("../../assets/passat/imgsMobile/daka/20.jpg"),
      //   url: 'https://new.qq.com/omn/20210725/20210725A09PAD00'
      // },
      {
        title: require("../../assets/passat/imgs/logo/21.png"),
        titleMobile: require("../../assets/passat/imgs/logo/21.png"),
        subtitle: '新帕萨特最大的亮点就是采用了双脸设计。同一款车，采用了两个不同的前脸，分别是星空前脸和点阵前脸。',
        imgurl: require("../../assets/passat/imgs/daka/21.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/21.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/9166109'
      },
      {
        title: require("../../assets/passat/imgs/logo/22.png"),
        titleMobile: require("../../assets/passat/imgs/logo/22.png"),
        subtitle: '新帕萨特两侧的大灯组比较纤细，搭配上横向的发光灯带，看起来未来感十足。下格栅底部的镀铬装饰条和两侧C字型饰条贯穿在一起，看起来质感更强烈。',
        imgurl: require("../../assets/passat/imgs/daka/22.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/22.jpg"),
        url: 'http://www.sohu.com/a/479517054_100160454'
      },
      // {
      //   title: require("../../assets/passat/imgs/logo/23.png"),
      //   titleMobile: require("../../assets/passat/imgs/logo/23.png"),
      //   subtitle: '新帕萨特的内饰设计在诸多细节中注入时尚元素，车内配备哈曼卡顿高级音响系统、手机无线充电等功能。',
      //   imgurl: require("../../assets/passat/imgs/daka/23.jpg"),
      //   imgurlMobile: require("../../assets/passat/imgsMobile/daka/23.jpg"),
      //   url: 'https://www.sohu.com/a/478395505_121091002'
      // },
      {
        title: require("../../assets/passat/imgs/logo/24.png"),
        titleMobile: require("../../assets/passat/imgs/logo/24.png"),
        subtitle: '新帕萨特提供黑、白、银、金和蓝5个车身颜色，内饰则有偏向科技的黑色搭配亮金属饰条和偏向商务的棕色两种风格可选。',
        imgurl: require("../../assets/passat/imgs/daka/24.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/24.jpg"),
        url: 'https://www.youcheyihou.com/news/1194811'
      },
      {
        title: require("../../assets/passat/imgs/logo/25.png"),
        titleMobile: require("../../assets/passat/imgs/logo/25.png"),
        subtitle: '新帕萨特长宽高分别为4948/1836/1469mm，轴距2871mm，其车身长度比现款略有增加（+15mm）。',
        imgurl: require("../../assets/passat/imgs/daka/25.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/25.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/9085103#pvareaid=6826274'
      },
      {
        title: require("../../assets/passat/imgs/logo/26.png"),
        titleMobile: require("../../assets/passat/imgs/logo/26.png"),
        subtitle: '新帕萨特大灯更凌厉了些，尾部整个贯穿式的尾灯，全系基本已经形成大众典型的设计语言了。',
        imgurl: require("../../assets/passat/imgs/daka/26.jpg"),
        imgurlMobile: require("../../assets/passat/imgsMobile/daka/26.jpg"),
        url: csvw_url + "/u/cms/www/202108/2016074636Zh.mp4"
      },
    ]
  },
  // 媒体试驾
  workspace5: {
    // 移动端
    shipin: [
      require("../../assets/passat/imgs/shijia/1.jpg"),
      require("../../assets/passat/imgs/shijia/2.jpg"),
      require("../../assets/passat/imgs/shijia/3.jpg"),

      require("../../assets/passat/imgs/shijia/4.jpg"),
      require("../../assets/passat/imgs/shijia/5.jpg"),
      require("../../assets/passat/imgs/shijia/6.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/passat/imgs/shijia/1.jpg"),
        require("../../assets/passat/imgs/shijia/2.jpg"),
        require("../../assets/passat/imgs/shijia/3.jpg"),
      ],
      [
        require("../../assets/passat/imgs/shijia/4.jpg"),
        require("../../assets/passat/imgs/shijia/5.jpg"),
        require("../../assets/passat/imgs/shijia/6.jpg"),
      ]
    ],
    // 封面
    fengurl: [],
    videourl: [
      csvw_url + "/u/cms/www/202108/2016061077Lb.mp4",
      csvw_url + "/u/cms/www/202108/20160607Ff13.mp4",
      csvw_url + "/u/cms/www/202108/2016055907z0.mp4",

      csvw_url + "/u/cms/www/202108/201607469lkW.mp4",
      csvw_url + "/u/cms/www/202108/20161106I44G.mp4",
      csvw_url + "/u/cms/www/202108/201612412d70.mp4",
    ],
  },
  // 现场直击(作废板块)
  // 现场直击
  workspace6: {
    
  }
}